import { API_USER_PREFIX } from '@shared/config/api/api-prefixes';
import { setCurrentUser } from '../model/slice';
import { currentUserApi } from './base';
import { CurrentUserDataResponse, CurrentUserInfo } from './credentials-user-types';

export const credentialsApi = currentUserApi.injectEndpoints({
    endpoints: (build) => ({
        currentUser: build.query<CurrentUserDataResponse, void>({
            query: () => `${API_USER_PREFIX}/current`,
            async onQueryStarted(_, { dispatch, queryFulfilled }) {
                try {
                    const { data } = await queryFulfilled;
                    dispatch(setCurrentUser(data));
                } catch (err) {
                    console.log(err);
                }
            },
            providesTags: ['CurrentUser'],
        }),
        userInfo: build.mutation<CurrentUserDataResponse, CurrentUserInfo>({
            query: (body) => ({
                url: '/user-info',
                method: 'POST',
                body,
            }),
        }),
    }),
});

export const { useLazyCurrentUserQuery, usePrefetch: usePrefetchCurrentUser, useUserInfoMutation } = credentialsApi;
